const iconLogo = ({ className }) => (
  <svg
    className={className}
    width="138"
    height="50"
    viewBox="4 2 137 50"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <path id="23sm3mbjnb" d="M0 0h15.217v17.391H0z" />
      <path id="mq4tzt7rrd" d="M0 0h17.391v23.913H0z" />
      <filter
        x="-1.8%"
        y="-4.1%"
        width="103.6%"
        height="111%"
        filterUnits="objectBoundingBox"
        id="or5npppjqa"
      >
        <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          stdDeviation="1.5"
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
        />
        <feColorMatrix
          values="0 0 0 0 0.0627451017 0 0 0 0 0.0941176489 0 0 0 0 0.156862751 0 0 0 0.100000001 0"
          in="shadowBlurOuter1"
          result="shadowMatrixOuter1"
        />
        <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter2" />
        <feGaussianBlur
          stdDeviation="1"
          in="shadowOffsetOuter2"
          result="shadowBlurOuter2"
        />
        <feColorMatrix
          values="0 0 0 0 0.0627451017 0 0 0 0 0.0941176489 0 0 0 0 0.156862751 0 0 0 0.0599999987 0"
          in="shadowBlurOuter2"
          result="shadowMatrixOuter2"
        />
        <feMerge>
          <feMergeNode in="shadowMatrixOuter1" />
          <feMergeNode in="shadowMatrixOuter2" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
    </defs>
    <g
      transform="translate(-17 -13)"
      filter="url(#or5npppjqa)"
      fill="none"
      fillRule="evenodd"
    >
      <path
        d="M42.055 15c4.109 3.496 6.742 8.856 6.742 14.872 0 10.536-8.077 19.076-18.044 19.076-3.106 0-6.027-.83-8.58-2.29 3.093 2.633 7.024 4.212 11.301 4.212 9.968 0 18.048-8.544 18.048-19.08 0-7.253-3.828-13.562-9.467-16.79"
        fill="#FFF"
      />
      <path
        d="M34.978 22.783A16.451 16.451 0 0 1 32.01 15c-.303 3.709.655 7.54 3 10.85 2.285 3.224 5.527 5.43 9.105 6.541.37-.902.668-1.839.884-2.805-3.94-1.001-7.544-3.307-10.022-6.803"
        fill="#FFF"
      />
      <g transform="translate(20 26.956)">
        <mask id="5ticrjd8nc" fill="#fff">
          <use xlinkHref="#23sm3mbjnb" />
        </mask>
        <path
          d="M2.612 4.757A32.092 32.092 0 0 1 0 0a30.582 30.582 0 0 0 4.423 10.383 30.033 30.033 0 0 0 6.48 7.008 18.367 18.367 0 0 0 4.314-1.687C10.291 13.368 5.895 9.685 2.612 4.757"
          fill="#FFF"
          mask="url(#5ticrjd8nc)"
        />
      </g>
      <path
        d="M28.1 27.514a24.715 24.715 0 0 1-1.578-2.731 22.876 22.876 0 0 0 3.187 7.13A22.332 22.332 0 0 0 39.41 40a17.774 17.774 0 0 0 2.328-2.814c-5.363-1.375-10.273-4.665-13.638-9.672M67.482 36.38c0 15.032-12.342 27.222-27.563 27.222-1.605 0-3.173-.144-4.702-.403A26.442 26.442 0 0 0 44.838 65c14.495 0 26.249-11.604 26.249-25.922 0-8.525-4.173-16.092-10.606-20.817 4.35 4.814 7.001 11.16 7.001 18.12z"
        fill="#FFF"
      />
      <path
        d="M52.457 15c4.55 4.376 7.36 10.378 7.36 17.01 0 13.38-11.443 24.235-25.559 24.235-1.15 0-2.278-.083-3.388-.219a25.473 25.473 0 0 0 8.266 1.365c13.444 0 24.342-10.33 24.342-23.08 0-8.08-4.387-15.189-11.021-19.311M153.119 33.478c-.917 0-1.836-.065-2.559-.223l.048-1.337c.773.2 1.765.357 2.704.357 1.86 0 3.163-.757 3.163-2.026 0-2.83-6.058-1.048-6.058-5.037 0-1.805 1.618-3.164 4.586-3.164.749 0 1.615.089 2.392.245l-.075 1.247c-.797-.22-1.69-.378-2.535-.378-1.857 0-2.825.735-2.825 1.895 0 2.852 6.083 1.157 6.083 4.99 0 1.893-1.832 3.431-4.924 3.431zm-3.787-10.071c-2.729-.4-4.032 1.628-4.032 5.482v4.41h-1.523V22.226h1.549c0 .78-.099 1.915-.316 2.897l.048.022c.458-1.648 1.712-3.386 4.344-3.097l-.07 1.359zm-11.752-.29c-1.784 0-3.042 1.182-3.382 3.031h6.471c.05-1.784-1.135-3.031-3.089-3.031zm4.66 4.124h-8.135c-.147 3.587 1.326 5.057 4.128 5.057 1.255 0 2.608-.312 3.477-.714l.144 1.248c-1.088.4-2.39.646-3.888.646-3.571 0-5.482-1.784-5.482-5.682 0-3.298 1.933-5.748 5.194-5.748 3.258 0 4.612 2.073 4.612 4.455 0 .158 0 .425-.05.738zm-13.764 6.058h-1.81l-2.849-7.664a27.622 27.622 0 0 1-.654-2.027h-.024c-.265.937-.579 1.85-.895 2.785l-2.364 6.906h-1.836l-3.74-11.073h1.736l2.22 7.13c.291.98.605 1.915.799 2.584h.025c.217-.824.507-1.738.796-2.583l2.488-7.13h1.833l2.511 7.107c.508 1.427.677 1.985.869 2.629h.025c.219-.802.46-1.47.82-2.584l2.342-7.153h1.643L128.476 33.3zm-19.633.18c-.918 0-1.836-.066-2.558-.224l.046-1.337c.774.2 1.762.357 2.704.357 1.859 0 3.167-.757 3.167-2.026 0-2.83-6.063-1.048-6.063-5.037 0-1.805 1.617-3.164 4.587-3.164.75 0 1.617.089 2.389.245l-.072 1.247c-.797-.22-1.69-.378-2.533-.378-1.862 0-2.826.735-2.826 1.895 0 2.852 6.084 1.157 6.084 4.99 0 1.893-1.834 3.431-4.925 3.431zm-5.887-.18v-7.195c0-1.85-.555-2.942-2.438-2.942-2.27 0-3.863 2.05-3.863 4.837v5.3h-1.522V22.226h1.546c0 .758-.071 1.873-.22 2.563l.048.022c.678-1.694 2.223-2.784 4.346-2.784 2.781 0 3.625 1.58 3.625 3.565V33.3h-1.522zM87.41 21.938c-.314-.736-.506-1.406-.722-2.162h-.025c-.218.714-.46 1.405-.75 2.117l-2.557 6.415h6.615l-2.56-6.37zm4.492 11.361-1.472-3.831h-7.508l-1.52 3.831h-1.62l6.131-15.038h1.669l6.107 15.038h-1.787zM86.158 50.87v-6.18c0-1.585-.454-2.522-1.98-2.522-1.844 0-3.138 1.759-3.138 4.15v4.552h-1.236v-9.505h1.256c0 .648-.06 1.604-.177 2.199l.041.02c.547-1.454 1.802-2.39 3.526-2.39 2.256 0 2.941 1.358 2.941 3.057v6.619h-1.233zm-9.382 0h1.237v-9.505h-1.237v9.505zm.63-11.32a.87.87 0 0 1-.884-.861.87.87 0 0 1 .883-.863c.489 0 .883.366.883.863 0 .475-.394.86-.883.86zM111.304 55.583c-.465 1.574-1.241 4.08-1.823 5.297-.968.251-3.842.86-6.25.86-9.084 0-12.579-6.014-12.579-11.6 0-7.267 5.28-12.314 13.55-12.314 2.445 0 4.814.537 5.861.752.273 1.97.47 3.58.66 5.513l-1.32.25c-1.204-3.866-3.415-5.083-5.979-5.083-4.386 0-7.143 4.833-7.143 10.167 0 6.407 3.148 10.847 7.337 10.847 2.758 0 4.699-1.934 6.369-5.12l1.317.43zM128.02 61.74v-1.233c2.334-.26 2.437-.37 2.437-3.684l-.035-14.602h-.135l-6.66 19.183h-1.032l-6.109-18.7h-.173l-.308 9.536c-.102 3.091-.172 4.88-.07 5.96.139 1.713.758 2.12 2.919 2.307v1.232h-7.55v-1.232c1.782-.186 2.264-.705 2.505-2.009.171-1.154.413-3.278.618-6.742l.479-7.933c.242-4.06.07-4.507-2.607-4.767v-1.23h6.66l5.698 15.792 5.835-15.792h6.624v1.23c-2.574.26-2.644.483-2.61 3.39l.312 14.377c.067 3.278.205 3.39 2.573 3.684v1.232h-9.371z"
        fill="#FFF"
      />
      <g transform="translate(140.652 37.826)">
        <mask id="nroo07n93e" fill="#fff">
          <use xlinkHref="#mq4tzt7rrd" />
        </mask>
        <path
          d="M17.391 18.102c-.21 1.416-.84 4.73-1.12 5.811H0v-1.231c2.59-.26 2.904-.445 2.904-3.5V4.657c0-3.018-.315-3.203-2.519-3.427V0h15.08c.035.596.21 3.205.351 5.29l-1.19.186c-.35-1.342-.7-2.346-1.224-2.98-.49-.671-1.399-1.006-3.501-1.006H8.643c-1.12 0-1.26.112-1.26 1.341v7.821h1.994c2.764 0 3.079-.15 3.604-2.755h1.19v7.301h-1.19c-.525-2.683-.804-2.794-3.604-2.794H7.383v6.741c0 1.75.175 2.57.735 2.867.525.335 1.469.41 2.73.41 1.854 0 2.869-.296 3.603-1.192.594-.781 1.188-1.862 1.75-3.425l1.19.297z"
          fill="#FFF"
          mask="url(#nroo07n93e)"
        />
      </g>
    </g>
  </svg>
)

const iconAdCollapsed = ({ style, className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="55"
    viewBox="4 2 20 55"
    fill="none"
    style={style}
    className={className}
  >
    <g filter="url(#filter0_d_111_1973)">
      <path
        d="M21 2C22.6569 2 24 3.34315 24 5L24 54C24 55.6569 22.6568 57 21 57L4 57L4.00001 2L21 2Z"
        fill="currentColor"
      />
    </g>
    <path
      d="M9 8L19 18M9 18L19 8"
      stroke="white"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 52V46.6667H9.33333V49.7333L17.7333 41.3333H14.6667V40H20V45.3333H18.6667V42.2667L10.2667 50.6667H13.3333V52H8Z"
      fill="white"
    />
    <defs>
      <filter
        id="filter0_d_111_1973"
        x="0"
        y="0"
        width="28"
        height="63"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="2" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_111_1973"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_111_1973"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
)

const iconAdControl = ({ style, className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="55"
    viewBox="4 2 20 55"
    fill="none"
    style={style}
    className={className}
  >
    <g filter="url(#filter0_d_111_1921)">
      <path
        d="M21 2C22.6569 2 24 3.34315 24 5L24 54C24 55.6569 22.6568 57 21 57L4 57L4.00001 2L21 2Z"
        fill="currentColor"
      />
    </g>
    <path
      d="M9 8L19 18M9 18L19 8"
      stroke="white"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.5 52.09L19.59 53L15.3 48.71L15.3 51.7L14 51.7L14 46.5L19.2 46.5L19.2 47.8L16.21 47.8L20.5 52.09ZM14 46.5L8.8 46.5L8.8 45.2L11.79 45.2L7.5 40.91L8.41 40L12.7 44.29L12.7 41.3L14 41.3L14 46.5Z"
      fill="white"
    />
    <defs>
      <filter
        id="filter0_d_111_1921"
        x="0"
        y="0"
        width="28"
        height="63"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="2" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_111_1921"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_111_1921"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
)

const iconAdClosed = ({ style, className, testid }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    style={style}
    className={className}
    data-testid={testid}
  >
    <path
      d="M0 7C0 3.13401 3.13401 0 7 0H25C28.866 0 32 3.13401 32 7V25C32 28.866 28.866 32 25 32H7C3.13401 32 0 28.866 0 25V7Z"
      fill="currentColor"
    />
    <path
      d="M10 22V16.6667H11.3333V19.7333L19.7333 11.3333H16.6667V10H22V15.3333H20.6667V12.2667L12.2667 20.6667H15.3333V22H10Z"
      fill="white"
    />
  </svg>
)

const iconUnfoldMore = ({ style }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="24"
    viewBox="9 3 6 18"
    width="24"
    style={style}
  >
    <path d="M0 0h24v24H0z" fill="none" />
    <path
      d="M12 5.83L15.17 9l1.41-1.41L12 3 7.41 7.59 8.83 9 12 5.83zm0 12.34L8.83 15l-1.41 1.41L12 21l4.59-4.59L15.17 15 12 18.17z"
      fill="currentColor"
    />
  </svg>
)

const iconChevronLeft = ({ style }) => (
  <svg viewBox="9 6 6 12" style={style}>
    <path
      d="M15.41 7.41 14 6l-6 6 6 6 1.41-1.41L10.83 12z"
      fill="currentColor"
    ></path>
  </svg>
)

const iconToastSuccess = ({ style }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="34"
    height="34"
    viewBox="9 0 34 34"
    fill="none"
    style={style}
    data-testid="toast-success"
  >
    <circle cx="26" cy="17" r="17" fill="#D1FADF" />
    <g filter="url(#filter0_dd_110_480)">
      <mask
        id="mask0_110_480"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="16"
        y="7"
        width="20"
        height="20"
      >
        <path d="M36 7H16V27H36V7Z" fill="white" />
      </mask>
      <g mask="url(#mask0_110_480)">
        <path
          d="M34.3333 16.2381V17.0048C34.3323 18.8018 33.7504 20.5504 32.6744 21.9896C31.5984 23.4289 30.086 24.4819 28.3628 24.9914C26.6395 25.5009 24.7977 25.4397 23.112 24.8169C21.4264 24.1942 19.9872 23.0432 19.0091 21.5357C18.031 20.0282 17.5665 18.2448 17.6847 16.4517C17.8029 14.6586 18.4976 12.9517 19.6652 11.5857C20.8328 10.2196 22.4106 9.26761 24.1635 8.87158C25.9163 8.47555 27.7502 8.65674 29.3916 9.38812M34.3333 10.3334L26 18.675L23.5 16.175"
          stroke="#039855"
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_dd_110_480"
        x="0.833252"
        y="3.83334"
        width="50.3334"
        height="50.3333"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="12" />
        <feGaussianBlur stdDeviation="8" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_110_480"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="3" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_110_480"
          result="effect2_dropShadow_110_480"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_110_480"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
)

const iconToastClose = ({ style, className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    style={style}
    className={className}
    data-testid="toast-close"
  >
    <g clipPath="url(#clip0_110_493)">
      <mask
        id="mask0_110_493"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="36"
        height="36"
      >
        <path d="M36 0H0V36H36V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_110_493)">
        <mask
          id="mask1_110_493"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="8"
          y="8"
          width="20"
          height="20"
        >
          <path d="M28 8H8V28H28V8Z" fill="white" />
        </mask>
        <g mask="url(#mask1_110_493)">
          <path
            d="M23 13L13 23M13 13L23 23"
            stroke="#667085"
            strokeWidth="1.66667"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
    </g>
    <defs>
      <clipPath id="clip0_110_493">
        <rect width="36" height="36" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

const iconCredits = ({ style, className, alt }) => (
  <svg
    style={style}
    className={className}
    role="img"
    width="38"
    height="42"
    viewBox="10 10 18 22"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <filter
        x="-3.6%"
        y="-18.8%"
        width="107.3%"
        height="140%"
        filterUnits="objectBoundingBox"
        id="d1svqinhma"
      >
        <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          stdDeviation="1.5"
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
        />
        <feColorMatrix
          values="0 0 0 0 0.0627451017 0 0 0 0 0.0941176489 0 0 0 0 0.156862751 0 0 0 0.100000001 0"
          in="shadowBlurOuter1"
          result="shadowMatrixOuter1"
        />
        <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter2" />
        <feGaussianBlur
          stdDeviation="1"
          in="shadowOffsetOuter2"
          result="shadowBlurOuter2"
        />
        <feColorMatrix
          values="0 0 0 0 0.0627451017 0 0 0 0 0.0941176489 0 0 0 0 0.156862751 0 0 0 0.0599999987 0"
          in="shadowBlurOuter2"
          result="shadowMatrixOuter2"
        />
        <feMerge>
          <feMergeNode in="shadowMatrixOuter1" />
          <feMergeNode in="shadowMatrixOuter2" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
      <path id="zrdzat6afb" d="M0 0h15.005v20H0z" />
    </defs>
    <g
      transform="translate(-265 -8)"
      filter="url(#d1svqinhma)"
      fill="none"
      fillRule="evenodd"
    >
      <g transform="translate(276 19)">
        <mask id="wb85rz6p5c" fill="#fff">
          <use xlinkHref="#zrdzat6afb" />
        </mask>
        <path
          d="M1.949 17.532c.067 0 .112.005.156 0 .484-.059.968-.112 1.45-.18.252-.036.449.008.619.221.307.386.638.754.956 1.132.035.042.047.105.07.157a97.854 97.854 0 0 0 1.37-3.416c.02-.05-.008-.152-.05-.188-.188-.16-.393-.299-.582-.457a1.777 1.777 0 0 0-1.186-.42H3.18l-1.232 3.151m11.114.015-1.257-3.208c-.113.02-.21.047-.304.047-.41.003-.818.001-1.227-.004a1.742 1.742 0 0 0-1.158.382 8.933 8.933 0 0 1-.574.436c-.13.088-.155.17-.094.32.267.655.519 1.315.777 1.974l.517 1.316c.026-.009.042-.009.049-.017l.8-.93c.548-.636.366-.558 1.24-.46.399.045.798.093 1.23.144M4.363 2.07c-.22 0-.442.006-.663 0-.264-.009-.431.107-.506.36-.071.237-.157.47-.214.71a2.825 2.825 0 0 1-1.334 1.84c-.243.15-.47.326-.697.5a.346.346 0 0 0-.13.415c.1.295.189.594.3.885.259.678.284 1.354.026 2.038-.103.273-.2.55-.29.827-.108.335-.076.441.205.653.198.148.4.29.612.418.686.42 1.11 1.021 1.303 1.798.069.276.166.546.256.817.057.171.178.27.364.27.35-.002.7 0 1.052-.009.655-.017 1.245.155 1.76.568.224.18.452.352.68.524.342.256.493.255.836-.002.239-.179.476-.362.712-.546a2.533 2.533 0 0 1 1.67-.544c.363.01.727.007 1.09.01.204.002.332-.104.393-.289.085-.252.177-.504.238-.762a2.856 2.856 0 0 1 1.362-1.867c.233-.14.449-.31.666-.476.142-.107.196-.252.134-.43-.1-.289-.184-.584-.295-.867a2.819 2.819 0 0 1 .003-2.148c.096-.242.18-.488.259-.735.104-.327.073-.43-.2-.639a7.51 7.51 0 0 0-.61-.42 2.8 2.8 0 0 1-1.314-1.81 7.116 7.116 0 0 0-.212-.71c-.111-.316-.198-.375-.531-.377-.273-.003-.546.003-.82.013-.591.024-1.155-.065-1.651-.413-.23-.16-.45-.334-.671-.504-.633-.485-.651-.48-1.286-.002-.316.24-.634.48-.976.676-.468.27-.997.261-1.52.228m-.102-.776c.169 0 .338-.004.507.001A1.69 1.69 0 0 0 5.873.927c.294-.226.585-.456.89-.666.51-.35.973-.349 1.486.005.299.206.586.431.874.654.332.257.702.384 1.123.374.383-.009.767-.019 1.15-.008.584.016.945.281 1.142.834.117.331.219.667.312 1.005.127.46.383.816.783 1.077.293.192.582.394.86.607.464.355.605.784.444 1.345a9.322 9.322 0 0 1-.305.904c-.213.53-.204 1.044.003 1.574.137.35.244.712.336 1.076.106.418-.036.78-.356 1.051-.272.23-.561.445-.864.632a2.046 2.046 0 0 0-.945 1.304c-.085.345-.226.676-.327 1.018-.022.076.006.178.037.258.489 1.26.982 2.517 1.473 3.776.176.451-.007.7-.493.647a58.593 58.593 0 0 1-1.82-.22c-.196-.028-.333.005-.467.171-.392.485-.804.955-1.21 1.43-.291.341-.617.284-.783-.139-.493-1.258-.985-2.516-1.476-3.775-.043-.11-.068-.199-.232-.199-.16 0-.195.075-.24.19-.49 1.26-.983 2.517-1.475 3.775-.175.445-.492.496-.804.13-.406-.476-.817-.946-1.211-1.43-.12-.147-.241-.179-.418-.156-.632.084-1.264.161-1.897.228-.427.046-.617-.216-.46-.62.495-1.272.992-2.542 1.49-3.81a.45.45 0 0 0-.001-.352 13.51 13.51 0 0 1-.336-1.057 1.836 1.836 0 0 0-.797-1.09 12.586 12.586 0 0 1-.828-.585c-.496-.382-.63-.792-.452-1.392.099-.336.216-.668.336-.997.16-.44.155-.873-.001-1.315a15.413 15.413 0 0 1-.375-1.187C-.09 5.51.11 5.125.487 4.83c.287-.223.586-.43.89-.63.394-.26.64-.613.776-1.062.122-.41.25-.82.413-1.215.18-.44.558-.615 1.012-.636.227-.01.455-.002.683-.002v.008"
          fill="#FFF"
          mask="url(#wb85rz6p5c)"
        />
      </g>
      <path
        d="M283.503 22.487c-2.39-.002-4.337 1.945-4.345 4.347a4.348 4.348 0 0 0 4.332 4.354 4.35 4.35 0 0 0 4.356-4.35 4.359 4.359 0 0 0-4.343-4.35m5.14 4.349a5.153 5.153 0 0 1-5.14 5.14c-2.829.005-5.138-2.302-5.142-5.136-.004-2.826 2.31-5.14 5.14-5.143 2.825-.003 5.143 2.313 5.142 5.139"
        fill="#FFF"
      />
      <path
        d="M281.812 26.438c.206.222.403.443.61.654.14.141.2.29.158.492-.06.29-.1.584-.152.913.287-.15.543-.277.79-.418a.524.524 0 0 1 .569-.003c.246.141.502.266.79.417-.051-.31-.081-.587-.145-.856-.061-.256.023-.434.206-.605.197-.183.373-.389.567-.595-.258-.037-.512-.09-.768-.107-.297-.019-.473-.162-.583-.433-.095-.235-.222-.458-.351-.719-.154.308-.291.573-.418.842a.473.473 0 0 1-.404.29c-.294.037-.586.086-.87.128m-.303 2.716c.079-.463.156-.95.247-1.435.02-.113-.006-.18-.083-.254-.325-.31-.644-.626-.967-.937-.14-.134-.235-.282-.17-.483.067-.202.234-.26.425-.287.444-.06.888-.122 1.329-.198a.336.336 0 0 0 .21-.153c.209-.397.405-.8.6-1.203.084-.175.196-.315.405-.314.209.001.32.138.404.315.194.403.39.806.6 1.202.037.07.133.14.21.153.449.077.9.136 1.35.201.184.027.34.094.402.288.06.193-.022.338-.158.47-.324.31-.642.626-.967.935-.083.08-.117.15-.094.27.084.433.152.87.228 1.305.034.194.036.38-.145.51-.173.125-.34.073-.511-.019-.39-.208-.783-.407-1.171-.619-.11-.06-.195-.057-.304.003-.411.223-.825.442-1.242.652-.312.156-.61-.036-.598-.402"
        fill="#FFF"
      />
    </g>
  </svg>
)

const iconSearch = ({ style, className, alt }) => (
  <svg
    style={style}
    className={className}
    aria-label={alt}
    role="img"
    viewBox="0 0 50 50"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="#fff"
      d="M49.37,44.92,34.47,29.58A18.72,18.72,0,0,0,37.79,18.9,18.9,18.9,0,1,0,18.9,37.79a18.69,18.69,0,0,0,10.36-3.11L44.13,50Zm-43-26A12.58,12.58,0,1,1,18.9,31.47,12.59,12.59,0,0,1,6.32,18.9Z"
    ></path>
  </svg>
)

const iconMenu = ({ style, className, alt }) => (
  <svg
    style={style}
    className={className}
    aria-label={alt}
    role="img"
    width="22"
    height="18"
    viewBox="0 0 22 18"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <filter
        x="-1.1%"
        y="-18.8%"
        width="102.2%"
        height="140%"
        filterUnits="objectBoundingBox"
        id="v37st6ntya"
      >
        <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          stdDeviation="1.5"
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
        />
        <feColorMatrix
          values="0 0 0 0 0.0627451017 0 0 0 0 0.0941176489 0 0 0 0 0.156862751 0 0 0 0.100000001 0"
          in="shadowBlurOuter1"
          result="shadowMatrixOuter1"
        />
        <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter2" />
        <feGaussianBlur
          stdDeviation="1"
          in="shadowOffsetOuter2"
          result="shadowBlurOuter2"
        />
        <feColorMatrix
          values="0 0 0 0 0.0627451017 0 0 0 0 0.0941176489 0 0 0 0 0.156862751 0 0 0 0.0599999987 0"
          in="shadowBlurOuter2"
          result="shadowMatrixOuter2"
        />
        <feMerge>
          <feMergeNode in="shadowMatrixOuter1" />
          <feMergeNode in="shadowMatrixOuter2" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
    </defs>
    <g
      filter="url(#v37st6ntya)"
      transform="translate(-1387 -32)"
      stroke="#FFF"
      strokeWidth="1.667"
      fill="none"
      fillRule="evenodd"
      strokeDasharray="0,0"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M1390.5 40h15m-15-5h15m-15 10h15" />
    </g>
  </svg>
)

const iconCurricula = ({ style, className }) => (
  <svg
    style={style}
    className={className}
    width="22"
    height="16"
    viewBox="0 0 22 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <path id="co0hml734a" d="M0 0h21.67v16H0z" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="ipbv2kbi2b" fill="#fff">
        <use xlinkHref="#co0hml734a" />
      </mask>
      <path
        d="M21.426 4.045 11.402.107a1.546 1.546 0 0 0-1.132 0L.245 4.045a.387.387 0 0 0-.245.36v1.021c0 .159.097.302.245.36l1.102.433c-.36.29-.57.727-.573 1.19v1.936a.776.776 0 0 0-.774.774v3.698l1.548-1.462 1.548 1.462v-3.698a.775.775 0 0 0-.774-.774V7.408l1.11-.37 6.838 2.686c.363.143.767.143 1.132 0l10.024-3.938a.387.387 0 0 0 .245-.36v-1.02a.387.387 0 0 0-.245-.36m-9.883 7.17 5.484-2.154v4.429c0 .16-.098.304-.248.361l-5.249 2.019a1.929 1.929 0 0 1-1.389 0l-5.249-2.019a.387.387 0 0 1-.248-.361V9.062l5.484 2.155c.455.178.96.178 1.415 0"
        fill="#3B78C3"
        mask="url(#ipbv2kbi2b)"
      />
    </g>
  </svg>
)

const iconPodcast = ({ style, className }) => (
  <svg
    style={style}
    className={className}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <path id="pep601hk4a" d="M0 0h19.118v20H0z" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="9szg67k8sb" fill="#fff">
        <use xlinkHref="#pep601hk4a" />
      </mask>
      <path
        d="M10.071 12.771H9.045a1.606 1.606 0 0 0-1.585 1.87l.782 4.688c.064.387.399.671.792.671h1.049a.802.802 0 0 0 .792-.671l.781-4.687a1.607 1.607 0 0 0-1.585-1.87m1.094-3.214a1.606 1.606 0 1 0-3.213 0 1.606 1.606 0 0 0 3.213 0M9.558 0C4.278 0 0 4.28 0 9.559c0 1.58.392 3.137 1.14 4.53a1.125 1.125 0 0 0 1.98-1.069 7.31 7.31 0 1 1 12.876 0 1.125 1.125 0 0 0 1.98 1.068A9.56 9.56 0 0 0 9.557 0M15.1 9.558a5.56 5.56 0 0 1-.225 1.558 1.125 1.125 0 0 1-2.159-.628 3.294 3.294 0 1 0-6.316 0 1.124 1.124 0 0 1-2.158.628A5.541 5.541 0 1 1 15.1 9.558"
        fill="#3B78C3"
        mask="url(#9szg67k8sb)"
      />
    </g>
  </svg>
)

const iconLiveEvents = ({ style, className }) => (
  <svg
    style={style}
    className={className}
    width="22"
    height="20"
    viewBox="0 0 22 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <path id="uw5gn8e0ta" d="M0 0h21.143v20H0z" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="m0lq69mhgb" fill="#fff">
        <use xlinkHref="#uw5gn8e0ta" />
      </mask>
      <path
        d="M10.57 8.454a3.02 3.02 0 1 0 0-6.038 3.02 3.02 0 0 0 0 6.038zm-.506 5.816c-.847-.939-4.928-5.213-4.928-8.835a5.435 5.435 0 1 1 10.87 0c0 3.622-4.082 7.896-4.93 8.835a.686.686 0 0 1-1.012 0zm10.734 5.03a1.726 1.726 0 0 1-1.396.7H1.739a1.739 1.739 0 0 1-1.666-2.238l2.087-6.957a1.75 1.75 0 0 1 1.666-1.24h.678c.294.598.623 1.179.984 1.74H3.826L1.74 18.26h17.663l-2.087-6.957h-1.662c.361-.56.69-1.141.985-1.739h.677a1.75 1.75 0 0 1 1.666 1.24l2.087 6.957c.16.526.06 1.097-.27 1.537z"
        fill="#3B78C3"
        mask="url(#m0lq69mhgb)"
      />
    </g>
  </svg>
)

const iconNewsFeed = ({ style, className }) => (
  <svg
    style={style}
    className={className}
    width="24"
    height="20"
    viewBox="0 0 24 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <path id="7bpx4m21ka" d="M0 0h22.857v20H0z" />
    </defs>
    <g transform="translate(.5)" fill="none" fillRule="evenodd">
      <mask id="4l9s4h7q8b" fill="#fff">
        <use xlinkHref="#7bpx4m21ka" />
      </mask>
      <path
        d="M8.095 12.381h3.81a.476.476 0 0 0 .476-.476v-.953a.476.476 0 0 0-.476-.476h-3.81a.476.476 0 0 0-.476.476v.953c0 .263.213.476.476.476zm12.857 4.762a.953.953 0 0 1-.952.952H5.55c.109-.305.163-.627.163-.952V1.905h15.238v15.238zM21.905 0H4.762a.952.952 0 0 0-.953.951V17.142a.953.953 0 0 1-1.904 0V.953A1.907 1.907 0 0 0 0 2.857v14.286A2.86 2.86 0 0 0 2.855 20H20a2.86 2.86 0 0 0 2.857-2.857V.953A.952.952 0 0 0 21.906 0h-.001zM8.095 16.19h3.81a.476.476 0 0 0 .476-.476v-.952a.476.476 0 0 0-.476-.476h-3.81a.476.476 0 0 0-.476.476v.952c0 .263.213.476.476.476zm10.476-1.904h-3.81a.476.476 0 0 0-.475.476v.952c0 .263.213.476.476.476h3.81a.476.476 0 0 0 .476-.476v-.952a.476.476 0 0 0-.477-.476zm0-3.81h-3.81a.476.476 0 0 0-.475.476v.953c0 .263.213.476.476.476h3.81a.476.476 0 0 0 .476-.476v-.953a.476.476 0 0 0-.477-.476zM8.095 8.571h10.476a.476.476 0 0 0 .477-.476v-3.81a.476.476 0 0 0-.477-.475H8.095a.476.476 0 0 0-.476.476v3.81c0 .262.213.475.476.475z"
        fill="#3B78C3"
        mask="url(#4l9s4h7q8b)"
      />
    </g>
  </svg>
)

const iconLinkedin = ({ style, className }) => (
  <svg
    style={style}
    className={className}
    width="18"
    height="18"
    viewBox="0 0 18 18"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.992 18h-3.697v-6.3c0-1.726-.656-2.69-2.022-2.69-1.487 0-2.263 1.004-2.263 2.69V18H6.447V6h3.563v1.616s1.071-1.982 3.616-1.982c2.544 0 4.366 1.554 4.366 4.768v7.599zM2.197 4.429A2.205 2.205 0 0 1 0 2.214C0 .992.983 0 2.197 0 3.41 0 4.393.992 4.393 2.214a2.205 2.205 0 0 1-2.196 2.214zM.357 18.001h3.715V6H.358v12z"
      fill="#3B78C3"
      fillRule="evenodd"
    />
  </svg>
)

const iconTwitter = ({ style, className }) => (
  <svg
    style={style}
    className={className}
    width="18"
    height="18"
    viewBox="0 0 18 18"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.485 0 9.792 6.619 5.245.001H0l6.876 10.007L0 18.001h1.554l6.012-6.99 4.802 6.99h5.245L10.482 7.622 17.04.001h-1.554zM8.354 10.098 7.657 9.1 2.114 1.17H4.5l4.474 6.4.697.996 5.815 8.318h-2.387l-4.745-6.787z"
      fill="#3B78C3"
      fillRule="evenodd"
    />
  </svg>
)

const iconArrowDropDownRounded = ({ className, style }) => (
  <svg
    className={className}
    style={style}
    focusable="false"
    aria-hidden="true"
    viewBox="0 0 24 24"
    data-testid="ArrowDropDownRoundedIcon"
  >
    <path d="m8.71 11.71 2.59 2.59c.39.39 1.02.39 1.41 0l2.59-2.59c.63-.63.18-1.71-.71-1.71H9.41c-.89 0-1.33 1.08-.7 1.71"></path>
  </svg>
)

const iconDropdown = ({ style, className, alt }) => (
  <svg
    className={className}
    style={style}
    focusable="false"
    aria-hidden="true"
    viewBox="5 5 14 14"
    data-testid="ExpandMoreIcon"
    aria-label={alt}
  >
    <path d="M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"></path>
  </svg>
)

export {
  iconLogo,
  iconAdCollapsed,
  iconAdControl,
  iconAdClosed,
  iconUnfoldMore,
  iconChevronLeft,
  iconToastSuccess,
  iconToastClose,
  iconCredits,
  iconSearch,
  iconMenu,
  iconCurricula,
  iconPodcast,
  iconLiveEvents,
  iconNewsFeed,
  iconLinkedin,
  iconTwitter,
  iconArrowDropDownRounded,
  iconDropdown
}
